import { PailMinusIcon } from './PailMinusIcon';

/**
 * author: Michael Irigoyen
 * id ECD25F41-E1C8-438E-BFF3-54F529504071
 * name pail-minus
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pail-minus.svg
 * tags
 */
export const BucketMinusIcon = PailMinusIcon;
export default BucketMinusIcon